'use client';

import type { ChatMessageProps } from './types';

export default function ChatMessage({ message }: ChatMessageProps) {
  const isUser = message.role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-[13px] font-gotham leading-[20px] ${
          isUser
            ? 'bg-brand text-brand-text rounded-br-md'
            : 'bg-[#F3F4F6] text-text-primary rounded-bl-md'
        }`}
      >
        <span className="whitespace-pre-wrap break-words">{message.content}</span>
        {message.isStreaming && !message.content && (
          <span className="inline-flex gap-1 py-1">
            <span className="w-1.5 h-1.5 bg-brand rounded-full animate-bounce [animation-delay:0ms]" />
            <span className="w-1.5 h-1.5 bg-brand rounded-full animate-bounce [animation-delay:150ms]" />
            <span className="w-1.5 h-1.5 bg-brand rounded-full animate-bounce [animation-delay:300ms]" />
          </span>
        )}
        {message.isStreaming && message.content && (
          <span className="inline-block w-0.5 h-4 bg-brand ml-0.5 animate-pulse align-text-bottom" />
        )}
      </div>
    </div>
  );
}
